import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, useHistory, useParams } from 'react-router-dom'
import { Divider, EInputTemplate, Input } from '../../components'
import 'react-dropdown/style.css'
import Dropdown from 'react-dropdown'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import ruLocale from 'date-fns/locale/ru'
import {
  Container,
  StyledEntity,
  Image,
  Title,
  StyledTitle,
  ProfileImage,
  Div,
  StyledInputWrapper,
  Label,
  StyledTextArea,
  SuccessText,
  FailedText,
  StyledSearch,
  StyledLabel,
  StyledInputPhoto,
  ClearImage,
  StyledPhotoFields,
  StyledSaveButton,
  StyledContainer,
  DeleteButton,
  SaveButton,
  BottomDiv,
  StyledLinkDiv,
  ButtonContainer,
  StyledDropDown,
} from './styled'
import {
  TForm,
  TPhoto,
  TTime,
  TAdditionalFields,
  TLoginValidationSchema,
  TGallery,
} from './types'
import { Assets } from '../../assets'
import { useTypedSelector, useValidation } from '../../hooks'
import { Log } from '../../utils'
import { RoutesTree } from '../../router'
import {
  getPlaceByIdAction,
  clearPlaceAction,
  updatePlaceAction,
  createPlaceAction,
  deletePlaceAction,
  showToastAction,
  deleteImageFromPlaceAction,
} from '../../store'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  WorkingTime,
  MakeData,
  ShowPhotos,
  Map,
  PhoneNumbers,
  SocialNets,
  Category,
  languages,
} from './components'
import _ from 'lodash'
import { generateErrorToast } from '../../helpers'
import moment from 'moment'
import add from 'date-fns/add'
import startOfDay from 'date-fns/startOfDay'

const PlaceInfo: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const [formNoValid, setFormNoValid] = useState<TPhoto>({
    photo: null,
  })
  const [language, setLanguage] = useState<string>('ru')

  const [form, setForm] = useState<TForm>({
    description: {
      ru: '',
      uk: '',
      en: '',
      pl: '',
      cs: '',
      de: '',
      es: '',
      fr: '',
      it: '',
      ch: '',
      hi: '',
      ja: '',
      ko: '',
      tr: '',
      gr: '',
      kt: '',
      sv: '',
      sk: '',
      th: '',
      hr: '',
      fi: '',
      sl: '',
    },
    networkName: '',
    medicalDirections: [],
    phones: [],
    title: {
      ru: '',
      uk: '',
      en: '',
      pl: '',
      cs: '',
      de: '',
      es: '',
      fr: '',
      it: '',
      ch: '',
      hi: '',
      ja: '',
      ko: '',
      tr: '',
      gr: '',
      kt: '',
      sv: '',
      sk: '',
      th: '',
      hr: '',
      fi: '',
      sl: '',
    },
    address: { ru: '', uk: '', en: '' },
    city: { ru: '', uk: '', en: '' },
    coordinates: {
      lat: 1,
      lng: 1,
    },
    cityLog: {
      lat: 1,
      lng: 1,
    },
    country: { ru: '', uk: '', en: '' },
    site: '',
    email: '',
    social: {
      viber: '',
      telegram: '',
      whatsApp: '',
      facebook: '',
      vk: '',
      instagram: '',
    },
    specialisation: { ru: '', uk: '', en: '', type: 1 },
  })
  const [timePicker, setTimePicker] = useState<TTime>({
    monday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    tuesday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    wednesday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    thursday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    friday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    saturday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
    sunday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      weekend: false,
    },
  })
  const [additionalFields, setAdditionalFields] = useState<TAdditionalFields>({
    everyday: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      enable: false,
    },
    lunch: {
      start: new Date().setHours(0, 0, 0, 0),
      end: new Date().setHours(20, 0, 0, 0),
      enable: false,
    },
    planned: false,
    aroundTheClock: false,
  })
  const [placePhotos, setPlacePhotos] = useState<TGallery>([])
  const [newPlacePhotos, setNewPlacePhotos] = useState<File[]>([])
  const [deletedPlacePhotos, setDeletedPlacePhotos] = useState<TGallery>([])

  const dispatch = useDispatch()

  const history = useHistory()

  const { place } = useTypedSelector(state => state.places)
  const { user } = useTypedSelector(state => state.user)

  if (!user?.access?.places) {
    return <Redirect to={RoutesTree.notFound.path} />
  }

  //eslint-disable-next-line
  const schema = useMemo<TLoginValidationSchema>(
    () => ({
      title: {
        condition:
          !!form.title.ru ||
          !!form.title.uk ||
          !!form.title.en ||
          !!form.title.cs ||
          !!form.title.de ||
          !!form.title.es ||
          !!form.title.fr ||
          !!form.title.it ||
          !!form.title.pl,
        error: 'Введите название',
      },
      address: {
        condition: !!form.address,
        error: 'Введите адрес',
      },
    }),
    [form],
  )

  const {
    validationSchema,
    validation,
    enableValidation,
    disableValidation,
    isEnabled,
    errors,
    isValid,
    //eslint-disable-next-line
  } = useValidation(schema)

  const takeImageHandler = (e: any) => {
    if (e.target?.type === 'file') {
      setFormNoValid(prev => ({
        ...prev,
        [e.target.name]: e.target?.files?.length ? e.target?.files[0] : null,
      }))
    }
  }

  const clearImage = (name: string) => {
    setFormNoValid(prev => ({
      ...prev,
      [name]: null,
    }))
  }

  const inputHandler = (e: any) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const inputMultiLangHandler = (e: any) => {
    setForm(prev => ({
      ...prev,
      //@ts-ignore
      [e.target.name]: { ...prev[e.target.name], [language]: e.target.value },
    }))
  }

  const onPressSaveChanges = async () => {
    try {
      const result = window.confirm('Обновить место?')

      if (!!form.specialisation) {
        if (result) {
          enableValidation()
          await validation()

          const data = new FormData()

          data.append('image', formNoValid.photo!)

          const dataImage = new FormData()

          newPlacePhotos.map(el => dataImage.append('image', el))

          if (id !== 'undefined') {
            dispatch(
              updatePlaceAction.request({
                data: MakeData({
                  form,
                  timePicker,
                  additionalFields,
                }),
                image:
                  !!formNoValid.photo && formNoValid.photo !== place?.meta?.logo
                    ? data
                    : '',
                id,
                dataImage: !!newPlacePhotos.length ? dataImage : '',
              }),
            )
          } else {
            dispatch(
              createPlaceAction.request({
                data: MakeData({
                  form,
                  timePicker,
                  additionalFields,
                }),
                image:
                  !!formNoValid.photo && formNoValid.photo !== place?.meta?.logo
                    ? data
                    : '',
                dataImage: !!newPlacePhotos.length ? dataImage : '',
              }),
            )
          }
        }

        !!deletedPlacePhotos.length &&
          id !== 'undefined' &&
          dispatch(
            deleteImageFromPlaceAction.request({
              id,
              image: deletedPlacePhotos.reduce(
                (acc, val) => `${acc}${!!acc ? '&' : '?'}photosIds[]=${val.id}`,
                '',
              ),
            }),
          )

        setNewPlacePhotos([])
        setDeletedPlacePhotos([])

        disableValidation()
      } else {
        dispatch(
          showToastAction.request(generateErrorToast('Выберите тип места')),
        )
      }
    } catch (error) {
      console.log(error)
      Log.ruddy('Event: onPressSaveChanges')
      //@ts-ignore
      error?.map(err => {
        dispatch(showToastAction.request(generateErrorToast(err)))
      })
    }
  }

  const onPressDeletePlace = () => {
    try {
      const result = window.confirm('Удалить место?')
      if (result) {
        dispatch(
          deletePlaceAction({
            authorization: '',
            id,
          }),
        )

        setPlacePhotos([])
        setNewPlacePhotos([])
        setDeletedPlacePhotos([])
        setFormNoValid({ photo: null })

        history.goBack()
      }
    } catch (error) {
      Log.ruddy('Event: onPressDeletePlace')
    }
  }

  const changeType = (type: string) => {
    setLanguage(type)
  }

  //eslint-disable-next-line
  useEffect(() => {
    if (id !== 'undefined') dispatch(getPlaceByIdAction.request({ id }))

    return () => {
      dispatch(clearPlaceAction())
      setPlacePhotos([])
      setNewPlacePhotos([])
      setDeletedPlacePhotos([])
      setFormNoValid({ photo: null })
    }
  }, [dispatch, id])

  //eslint-disable-next-line
  useEffect(() => {
    if (id !== 'undefined') {
      //@ts-ignore
      setForm(prev => ({
        ...prev,
        description: place?.description ?? {
          ru: '',
          uk: '',
          en: '',
          pl: '',
          cs: '',
          de: '',
          es: '',
          fr: '',
          it: '',
          ch: '',
          hi: '',
          ja: '',
          ko: '',
          tr: '',
          gr: '',
          kt: '',
          sv: '',
          sk: '',
          th: '',
          hr: '',
          fi: '',
          sl: '',
        },
        group: place?.networkName ?? '',
        phones: place?.contactInfo?.phone ?? [],
        medicalDirections: place?.medicalDirections ?? [],
        title: place?.name ?? {
          ru: '',
          uk: '',
          en: '',
          pl: '',
          cs: '',
          de: '',
          es: '',
          fr: '',
          it: '',
          ch: '',
          hi: '',
          ja: '',
          ko: '',
          tr: '',
          gr: '',
          kt: '',
          sv: '',
          sk: '',
          th: '',
          hr: '',
          fi: '',
          sl: '',
        },
        address: place?.contactInfo?.location?.address ?? {
          ru: '',
          en: '',
          uk: '',
        },
        city: place?.contactInfo?.location?.district ?? {
          ru: '',
          en: '',
          uk: '',
        },
        coordinates: {
          lat: place?.contactInfo?.location?.coords?.coordinates[1] ?? 1,
          lng: place?.contactInfo?.location?.coords?.coordinates[0] ?? 1,
        },
        email: place?.contactInfo?.email ?? '',
        site: place?.contactInfo?.site ?? '',
        social: {
          viber: place?.contactInfo?.social?.viber ?? '',
          telegram: place?.contactInfo?.social?.telegram ?? '',
          whatsApp: place?.contactInfo?.social?.whatsApp ?? '',
          facebook: place?.contactInfo?.social?.facebook ?? '',
          vk: place?.contactInfo?.social?.vk ?? '',
          instagram: place?.contactInfo?.social?.instagram ?? '',
        },
        specialisation: place?.specialisation ?? {
          ru: '',
          en: '',
          uk: '',
          type: 1,
        },
      }))
      setFormNoValid(prev => ({
        ...prev,
        photo: place?.meta?.logo ?? null,
      }))
      setPlacePhotos(place?.meta?.photos ?? [])

      place?.schedule?.lunchHours &&
        setAdditionalFields(prev => ({
          ...prev,
          lunch: {
            ...place?.schedule?.lunchHours,
            start: add(startOfDay(new Date()), {
              hours: Number(
                String(place?.schedule?.lunchHours?.start).split(':')?.[0],
              ),
              minutes: Number(
                String(place?.schedule?.lunchHours?.start).split(':')?.[1],
              ),
            }).getTime(),
            end: add(startOfDay(new Date()), {
              hours: Number(
                String(place?.schedule?.lunchHours?.end).split(':')?.[0],
              ),
              minutes: Number(
                String(place?.schedule?.lunchHours?.end).split(':')?.[1],
              ),
            }).getTime(),
          },
        }))

      if (
        !!place?.schedule?.workingHours &&
        typeof place?.schedule?.workingHours?.monday.start === 'string' &&
        typeof place?.schedule?.workingHours?.monday.end === 'string' &&
        typeof place?.schedule?.workingHours?.tuesday.start === 'string' &&
        typeof place?.schedule?.workingHours?.tuesday.end === 'string' &&
        typeof place?.schedule?.workingHours?.wednesday.start === 'string' &&
        typeof place?.schedule?.workingHours?.wednesday.end === 'string' &&
        typeof place?.schedule?.workingHours?.thursday.start === 'string' &&
        typeof place?.schedule?.workingHours?.thursday.end === 'string' &&
        typeof place?.schedule?.workingHours?.friday.start === 'string' &&
        typeof place?.schedule?.workingHours?.friday.end === 'string' &&
        typeof place?.schedule?.workingHours?.saturday.start === 'string' &&
        typeof place?.schedule?.workingHours?.saturday.end === 'string' &&
        typeof place?.schedule?.workingHours?.sunday.start === 'string' &&
        typeof place?.schedule?.workingHours?.sunday.end === 'string'
      ) {
        if (
          place?.schedule?.details?.everyDay ||
          place?.schedule?.details?.allDay
        ) {
          if (place?.schedule?.details?.everyDay) {
            !!place?.schedule?.workingHours &&
              setAdditionalFields(prev => ({
                ...prev,
                everyday: {
                  start: add(startOfDay(new Date()), {
                    hours: Number(
                      String(
                        place?.schedule?.workingHours?.monday?.start,
                      ).split(':')?.[0],
                    ),
                    minutes: Number(
                      String(
                        place?.schedule?.workingHours?.monday?.start,
                      ).split(':')?.[1],
                    ),
                  }).getTime(),
                  end: add(startOfDay(new Date()), {
                    hours: Number(
                      String(place?.schedule?.workingHours?.monday?.end).split(
                        ':',
                      )?.[0],
                    ),
                    minutes: Number(
                      String(place?.schedule?.workingHours?.monday?.end).split(
                        ':',
                      )?.[1],
                    ),
                  }).getTime(),
                  enable: true,
                },
              }))

            setTimePicker(prev => ({
              ...prev,
              ...Object.keys(timePicker).reduce(
                (i, el) => ({
                  ...i,
                  [el]: {
                    weekend: false,
                    start: add(startOfDay(new Date()), {
                      hours: Number(
                        String(
                          place?.schedule?.workingHours?.monday?.start,
                        ).split(':')?.[0],
                      ),
                      minutes: Number(
                        String(
                          place?.schedule?.workingHours?.monday?.start,
                        ).split(':')?.[1],
                      ),
                    }).getTime(),
                    end: add(startOfDay(new Date()), {
                      hours: Number(
                        String(
                          place?.schedule?.workingHours?.monday?.end,
                        ).split(':')?.[0],
                      ),
                      minutes: Number(
                        String(
                          place?.schedule?.workingHours?.monday?.end,
                        ).split(':')?.[1],
                      ),
                    }).getTime(),
                  },
                }),
                {},
              ),
            }))
          } else {
            setAdditionalFields(prev => ({
              ...prev,
              everyday: {
                start: new Date().setHours(0, 0, 0, 0),
                end: new Date().setHours(20, 0, 0, 0),
                enable: false,
              },
            }))
          }

          if (place?.schedule?.details?.allDay) {
            setAdditionalFields(prev => ({ ...prev, aroundTheClock: true }))
            setTimePicker(prev => ({
              ...prev,
              ...Object.keys(timePicker).reduce(
                (i, el) => ({
                  ...i,
                  [el]: {
                    weekend: false,
                    start: new Date().setHours(0, 0, 0, 0),
                    end: new Date().setHours(23, 59, 59, 999),
                  },
                }),
                {},
              ),
            }))
          } else {
            setAdditionalFields(prev => ({ ...prev, aroundTheClock: false }))
          }
        } else {
          !!place?.schedule?.workingHours
            ? setTimePicker(prev => ({
                ...prev,
                ...Object.keys(timePicker).reduce(
                  (i, el) => ({
                    ...i,
                    [el]: {
                      weekend: place?.schedule?.workingHours
                        ? //@ts-ignore
                          place?.schedule?.workingHours[
                            (el as keyof typeof timePicker) ?? ''
                          ]?.end === '00:00'
                          ? true
                          : false
                        : false,
                      start: add(startOfDay(new Date()), {
                        hours: Number(
                          String(
                            place?.schedule?.workingHours[
                              (el as keyof typeof timePicker) ?? ''
                            ]?.start,
                          ).split(':')?.[0],
                        ),
                        minutes: Number(
                          String(
                            place?.schedule?.workingHours[
                              (el as keyof typeof timePicker) ?? ''
                            ]?.start,
                          ).split(':')?.[1],
                        ),
                      }).getTime(),
                      end: add(startOfDay(new Date()), {
                        hours: Number(
                          String(
                            place?.schedule?.workingHours[
                              (el as keyof typeof timePicker) ?? ''
                            ]?.end,
                          ).split(':')?.[0],
                        ),
                        minutes: Number(
                          String(
                            place?.schedule?.workingHours[
                              (el as keyof typeof timePicker) ?? ''
                            ]?.end,
                          ).split(':')?.[1],
                        ),
                      }).getTime(),
                    },
                  }),
                  {},
                ),
              }))
            : setTimePicker(prev => ({
                ...prev,
                ...Object.keys(timePicker).reduce(
                  (i, el) => ({
                    ...i,
                    [el]: {
                      weekend: false,
                      start: new Date().setHours(0, 0, 0, 0),
                      end: new Date().setHours(20, 0, 0, 0),
                    },
                  }),
                  {},
                ),
              }))

          setAdditionalFields(prev => ({
            ...prev,
            everyday: {
              start: new Date().setHours(0, 0, 0, 0),
              end: new Date().setHours(20, 0, 0, 0),
              enable: false,
            },
            planned: false,
            aroundTheClock: false,
          }))
        }

        if (place?.schedule?.details?.byAppointment) {
          setAdditionalFields(prev => ({ ...prev, planned: true }))
        } else {
          setAdditionalFields(prev => ({ ...prev, planned: false }))
        }
      } else {
        setTimePicker(prev => ({
          ...prev,
          ...Object.keys(timePicker).reduce(
            (i, el) => ({
              ...i,
              [el]: {
                weekend: false,
                start: new Date().setHours(0, 0, 0, 0),
                end: new Date().setHours(20, 0, 0, 0),
              },
            }),
            {},
          ),
        }))
      }
    } else {
      setNewPlacePhotos([])

      history.push(`/place-info/${place?._id}`)
    }
  }, [place])

  const handleBack = () => {
    history.goBack()
  };

  const navigatorFeedbacksHandler = () => {
    history.push(`/review/${place?._id}`)
  };

  return (
    <Container>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
        <StyledTitle>
          <StyledLinkDiv onClick={handleBack}>
            <Image src={Assets.LEFT_ARROW_ICON} />
          </StyledLinkDiv>
          <Title>Места</Title>
          <Div> </Div>
        </StyledTitle>

        <Divider height={10} />

        <StyledPhotoFields>
          {typeof formNoValid?.photo === 'string' ? (
            <ProfileImage src={formNoValid?.photo} />
          ) : !!formNoValid.photo ? (
            <SuccessText>Выбрано</SuccessText>
          ) : (
            <FailedText>Не выбрано</FailedText>
          )}

          <StyledSearch>
            <StyledLabel htmlFor="photo">
              <Image src={Assets.DOWNLOAD_ARROW_ICON} />
            </StyledLabel>
            <StyledInputPhoto
              id="photo"
              name="photo"
              type="file"
              value=""
              accept="image/*"
              onChange={v => takeImageHandler(v)}
            />

            <ClearImage
              onClick={() => clearImage('photo')}
              src={Assets.CYAN_ICON}
            />
          </StyledSearch>
        </StyledPhotoFields>

        <Divider height={10} />

        <Label>Язык</Label>

        <Divider height={10} />

        <StyledDropDown>
          <Dropdown
            options={languages}
            onChange={option => changeType(option.value)}
            value={language}
            placeholder="Виберите язык"
          />
        </StyledDropDown>

        <Divider height={30} />

        <StyledEntity>
          <Input
            label={'Название - ' + language}
            name="title"
            value={form.title[language as keyof typeof form.title] ?? ''}
            placeholder="Введите название"
            template={EInputTemplate.NAME}
            error={schema.title.error || ''}
            onChange={v => inputMultiLangHandler(v)}
            isValid={!isEnabled || validationSchema.title}
          />
        </StyledEntity>

        <Divider height={10} />

        <StyledInputWrapper>
          <Label>Описание - {language}</Label>

          <Divider height={10} />

          <StyledTextArea
            required
            name="description"
            placeholder="Введите описание"
            value={
              form.description[language as keyof typeof form.description] ?? ''
            }
            onChange={inputMultiLangHandler}
          ></StyledTextArea>
        </StyledInputWrapper>

        <Divider height={20} />

        <StyledEntity>
          <Input
            label="Email"
            name="email"
            value={form.email ?? ''}
            placeholder="Введите email"
            template={EInputTemplate.NAME}
            onChange={v => inputHandler(v)}
          />
        </StyledEntity>

        <Divider height={10} />

        <StyledEntity>
          <Input
            label="Сайт"
            name="site"
            value={form.site ?? ''}
            placeholder="Введите сайт"
            template={EInputTemplate.NAME}
            onChange={v => inputHandler(v)}
          />
        </StyledEntity>

        <Divider height={10} />

        {id !== 'undefined' && (
          <>
            <StyledEntity>
              <Input
                label="Создан"
                name="created"
                value={`${place?.createdBy?.email ?? '-'} ${moment(
                  place?.createdAt ?? '-',
                ).format('HH:mm DD.MM.YYYY')}`}
                template={EInputTemplate.DEFAULT}
                onChange={() => {}}
                disabled
              />
            </StyledEntity>

            <Divider height={10} />

            <StyledEntity>
              <Input
                label="Изменён"
                name="edited"
                value={`${place?.updatedBy?.email ?? '-'} ${moment(
                  place?.updatedAt ?? '-',
                ).format('HH:mm DD.MM.YYYY')}`}
                template={EInputTemplate.DEFAULT}
                onChange={() => {}}
                disabled
              />
            </StyledEntity>

            <Divider height={20} />
          </>
        )}

        <Map
          form={form}
          setForm={setForm}
          schema={schema}
          validationSchema={validationSchema}
          isEnabled={isEnabled}
        />

        <Divider height={30} />

        <Category form={form} setForm={setForm} />

        <Divider height={10} />

        <PhoneNumbers form={form} setForm={setForm} />

        <Divider height={10} />

        <WorkingTime
          timePicker={timePicker}
          setTimePicker={setTimePicker}
          additionalFields={additionalFields}
          setAdditionalFields={setAdditionalFields}
        />

        <Divider height={10} />

        <SocialNets form={form} setForm={setForm} />

        <Divider height={30} />

        {id !== 'undefined' && (
          <ButtonContainer>
            <StyledSaveButton onClick={navigatorFeedbacksHandler}>
              Отзывы места
            </StyledSaveButton>
          </ButtonContainer>
        )}

        <ShowPhotos
          items={[...placePhotos, ...newPlacePhotos]}
          setItems={setNewPlacePhotos}
          setDeleted={setDeletedPlacePhotos}
          setFixedItems={setPlacePhotos}
          type="Галерея"
        />

        <Divider height={20} />

        {id === 'undefined' ? (
          <StyledSaveButton onClick={onPressSaveChanges}>
            Создать
          </StyledSaveButton>
        ) : (
          <StyledContainer>
            <DeleteButton onClick={onPressDeletePlace}>Удалить</DeleteButton>

            <SaveButton onClick={onPressSaveChanges}>Сохранить</SaveButton>
          </StyledContainer>
        )}

        <Divider height={10} />

        <BottomDiv />
      </LocalizationProvider>
    </Container>
  )
}

export default PlaceInfo
